import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kanban-day-summary",attrs:{"aria-label":"Resumo do dia"}},_vm._l((_vm.items),function(item){return _c('span',{key:item.key,staticClass:"kanban-day-summary__item",class:`kanban-day-summary__item--${item.key}`},[_c(VIcon,{staticClass:"mr-1",attrs:{"small":""}},[_vm._v(_vm._s(item.icon))]),_c('strong',{staticClass:"mr-1"},[_vm._v(_vm._s(item.value))]),_vm._v(" "+_vm._s(item.value === 1 ? item.singular : item.plural)+" ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }